import { WindowWithReactNativeWebView } from "@tableyeti/webview-messages";
import { IsLoadedMessage, BasecampMessage } from "@tableyeti/webview-messages/src/events/basecamp";

export const sendWebviewMessage = (message: BasecampMessage) => {
  (window as unknown as WindowWithReactNativeWebView).ReactNativeWebView?.postMessage(
    JSON.stringify(message),
  );
};

export const setBasecampIsLoaded = () => sendWebviewMessage(IsLoadedMessage);
